export default __webpack_public_path__ + "static/media/bad.0fd5280d.svg";